/* eslint-disable react/jsx-no-useless-fragment */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import RoundedButton from '../buttons/Rounded';
import CardLayout from '../partials/CardLayout';
import CardTags from '../partials/CardTags';
import FilmTitle from '../partials/FilmTitle';
import Link from '../partials/Link';

import styles from '../../../styles/cards/square.module.scss';

const propTypes = {
    item: AppPropTypes.listItem,
    isLink: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    item: null,
    isLink: true,
    className: null,
};

const SquareCard = ({ item, isLink, className }) => {
    const {
        type,
        title,
        url: eventUrl = null,
        film = null,
        image = null,
        isOnline = false,
        product = null,
        startDate = null,
        isFree,
    } = item;
    const { url: filmUrl = null } = film || {};
    const isFilm = filmUrl !== null;
    const url = isFilm ? filmUrl : eventUrl;
    const { type: productType = null, amount = null } = product || {};

    const isForum = productType === 'forum';
    const isEvent = productType !== 'forum' && type === 'event';
    const isScreening = type === 'screening';

    return (
        <CardLayout
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            type={type}
            isStacked
            url={url}
            image={image}
            tags={<CardTags withOnline={isOnline} withFree={amount === 0 || isFree} />}
            tagsPosition="right"
            pillContent={<FormattedDate value={startDate} day="numeric" month="short" />}
            pillPosition="left"
            isDark={false}
        >
            <div className={styles.content}>
                <div className={styles.info}>
                    {isEvent || isForum || isScreening ? (
                        <p className={styles.eventType}>
                            {isScreening ? (
                                <FormattedMessage
                                    defaultMessage="Screening"
                                    description="Entity type heading"
                                />
                            ) : null}
                            {isForum ? (
                                <FormattedMessage
                                    defaultMessage="Forum"
                                    description="Entity type heading"
                                />
                            ) : null}
                            {isEvent ? (
                                <FormattedMessage
                                    defaultMessage="Event"
                                    description="Entity type heading"
                                />
                            ) : null}
                        </p>
                    ) : null}
                    {type === 'screening' && film !== null ? (
                        <FilmTitle
                            linkClassName={styles.link}
                            titleClassName={styles.title}
                            alternateTitleClassName={styles.alternateTitle}
                            metaItemClassName={styles.meta}
                            item={film}
                            url={url}
                            isLink
                        />
                    ) : (
                        <>
                            {isLink ? (
                                <h2 className={styles.title}>
                                    <Link className={styles.link} href={url}>
                                        {title}
                                    </Link>
                                </h2>
                            ) : (
                                <h2 className={styles.title}>{title}</h2>
                            )}
                        </>
                    )}
                </div>
                {url !== null ? (
                    <div className={styles.buttonContainer}>
                        <RoundedButton isDark>
                            <Link href={url} className={styles.buttonLink}>
                                <FormattedMessage
                                    defaultMessage="Learn more"
                                    description="Button label"
                                />
                            </Link>
                        </RoundedButton>
                    </div>
                ) : null}
            </div>
        </CardLayout>
    );
};

SquareCard.propTypes = propTypes;
SquareCard.defaultProps = defaultProps;

export default SquareCard;
